import { createAction, props } from '@ngrx/store';
import {
  IScanDocumentData,
  IScanDocumentModel,
  IScanIntroData,
  IScanMethodData,
  IScanValidateData,
  TLastScanActions
} from '@partners/api';

export class ScanActions {
  //-----Scan Document------//
  static resetScanDocument = createAction('[Scan Document] Reset State');

  static loadScanDocument = createAction('[Scan Document] Load', props<{ selectedDocId: number }>());

  static loadScanIntroSuccess = createAction(
    '[Scan Document] Load Scan Intro Success',
    props<{ data: IScanIntroData }>()
  );
  static loadScanMethodSuccess = createAction(
    '[Scan Document] Load Scan Method Success',
    props<{ data: IScanMethodData }>()
  );
  static submitScanDocument = createAction('[Scan Document] Submit', props<{ model: IScanDocumentModel }>());

  static submitScanDocumentSuccess = createAction(
    '[Scan Document] Submit Success',
    props<{ data: IScanDocumentData }>()
  );

  static submitScanDocumentFailure = createAction('[Scan Document] Submit Failure', props<{ error: any }>());
  static updateLastScanAction = createAction(
    '[Scan Document] Update Last Scan Action',
    props<{ lastScanAction: TLastScanActions }>()
  );
  static updateMaxAttemptsError = createAction(
    '[Scan Document] update max attempts error',
    props<{ isMaxAttemptsExceeded: boolean }>()
  );
  static uploadDocument = createAction(
    '[Upload Document] Submit Upload Document',
    props<{ model: IScanDocumentModel }>()
  );

  static uploadDocumentSuccess = createAction(
    '[Upload Document] Submit Upload Document Success',
    props<{ data: IScanDocumentData }>()
  );
  static saveScanValidate = createAction('[Scan Validate] save scan validate', props<{ data: IScanValidateData }>());

  static scanValidateFailure = createAction('[Scan Validate] Scan Validate Failure', props<{ error: any }>());

  static deleteDocument = createAction('[Upload Document] Delete Document');

  static resetUploadedDocuments = createAction('[Upload Document] Reset Uploaded Documents');

  static deleteBackSideDocument = createAction('[Upload Document] Delete Back Side Document');

  static deleteFrontSideDocument = createAction('[Upload Document] Delete Front Side Document');
}
